import { ButtonSize } from './types';
import { TypographyVariant } from '../../tokens';

export const buttonTextSize = (buttonSize: ButtonSize): TypographyVariant => {
  switch (buttonSize) {
    case 'xxs':
      return '13_400';
    case 'xs':
      return '13_400';
    case 's':
      return '13_400';
    case 'm':
      return '14_400';
    case 'l':
      return '16_400';
    case 'xl':
      return '16_400';
    default:
      return '14_400';
  }
};
